import { Check, Headset, Medal, Timer, Truck } from './icons';
import { useI18n } from '../../hooks/useI18n';
import { type TrustBadgeConfig, type TrustBadgeId, useSettings } from '../../store/settingsStore';

const ICONS = { truck: Truck, timer: Timer, headset: Headset, medal: Medal, check: Check };
const VARIANTS = {
  brand: 'border-brand/50 bg-brand/20 text-ink/90 shadow-brand/10 [&_svg]:text-brand',
  accent: 'border-accent/50 bg-accent/20 text-ink/90 shadow-accent/10 [&_svg]:text-accent',
  success: 'border-success/50 bg-success/25 text-ink/90 shadow-success/10 [&_svg]:text-success',
  warning: 'border-warning/50 bg-warning/25 text-ink/90 shadow-warning/10 [&_svg]:text-warning',
  info: 'border-info/50 bg-info/25 text-ink/90 shadow-info/10 [&_svg]:text-info',
  danger: 'border-danger/50 bg-danger/20 text-ink/90 shadow-danger/10 [&_svg]:text-danger',
};

function trustBadgeLabel(badge: TrustBadgeConfig, language: string) {
  return language === 'en' ? badge.labelEn : badge.labelEs;
}

export function TrustBadgePreview({ badge, className = '' }: { badge: TrustBadgeConfig; className?: string }) {
  const { language } = useI18n();
  if (!badge.enabled) return null;
  const Icon = ICONS[badge.icon];
  return (
    <span className={`trust-badge-item inline-flex items-center gap-1 rounded-full border px-2.5 py-1 text-xs font-medium backdrop-blur-md shadow-sm ${VARIANTS[badge.variant]} ${className}`}>
      <Icon className={`checkmark-icon h-3.5 w-3.5 ${badge.icon === 'truck' ? 'truck-icon' : ''}`} aria-hidden="true" />
      {trustBadgeLabel(badge, language)}
    </span>
  );
}

export default function TrustBadgePill({ id, className = '' }: { id: TrustBadgeId; className?: string }) {
  const { trustBadges } = useSettings();
  const badge = trustBadges.find((item) => item.id === id);
  if (!badge) return null;
  return <TrustBadgePreview badge={badge} className={className} />;
}
